import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
/**
 * Zustand store for managing shopping bag state with session storage persistence
 *
 * This store currently supports single-item checkout only. When a new product
 * is added, it clears the existing bag contents.
 */
export const useBagStore = create()(persist((set, get) => ({
    /** Initial empty products array */
    products: [],
    /**
     * Adds a product to the bag
     * Currently clears existing products to support single-item checkout only
     * @param product - The product to add to the bag
     */
    addToBag: (product) => {
        // TODO: Remove clearBag call when multi-item checkout is implemented
        get().clearBag();
        set((state) => ({
            products: [...state.products, product],
        }));
    },
    /**
     * Returns all products currently in the bag
     * @returns Array of BagProduct items
     */
    listBag: () => {
        return get().products;
    },
    /**
     * Removes all products from the bag
     */
    clearBag: () => {
        set({ products: [] });
    },
}), {
    name: 'bag-storage', // unique name for the storage key
    storage: createJSONStorage(() => sessionStorage), // Use sessionStorage
}));
